import {
    SonoraEntityType,
    SonoraStickyNotes,
    SonoraStickyNotesSuggestion,
} from 'owa-editor-sonora-types';
import type { Suggestion } from 'owa-userdataservice';
import { trace } from 'owa-trace';

export default function parseStickyNotesSuggestions(
    suggestion: Suggestion
): SonoraStickyNotesSuggestion | undefined {
    try {
        const data = JSON.parse(suggestion.encodedJsonData);

        // If the NoteSource field is present, then we have a plaintext sticky note.
        // Otherwise, we have a rich sticky note.
        // With plaintext sticky notes, the body and bodyPreview fields are identical.
        if (data) {
            const suggestions = data.map(userDataInfo =>
                !!userDataInfo.NoteSource
                    ? <SonoraStickyNotes>{
                          type: SonoraEntityType.StickyNotes,
                          subject: userDataInfo.NoteSource.Subject,
                          bodyPreview: userDataInfo.NoteSource.Preview,
                          body: userDataInfo.NoteSource.Preview,
                          dateTimeCreatedUTC: userDataInfo.NoteSource.DateTimeCreated,
                          dateTimeLastModifiedUTC: userDataInfo.NoteSource.DateTimeLastModified,
                      }
                    : <SonoraStickyNotes>{
                          type: SonoraEntityType.StickyNotes,
                          subject: userDataInfo.Title,
                          bodyPreview: userDataInfo.Document.BodyPreview,
                          body: userDataInfo.Document.Body,
                          dateTimeCreatedUTC: userDataInfo.CreatedAt,
                          dateTimeLastModifiedUTC: userDataInfo.LastModified,
                      }
            );
            return {
                suggestions: suggestions,
                logicalId: suggestion?.logicalId,
                traceId: suggestion?.traceId,
            };
        }
    } catch (error) {
        trace.warn(`[HoneybeeSonora|parseStickyNotesSuggestion] Error: ${error}`);
    }
    return undefined;
}
